import React from 'react';

const SearchMagicAi = () => {
  const theme = 'light'

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.125 6.66667V4.79167C3.125 3.87119 3.87119 3.125 4.79167 3.125H6.66667M3.125 13.3333V15.2083C3.125 16.1288 3.87119 16.875 4.79167 16.875H6.66667M13.3333 3.125H15.2083C16.1288 3.125 16.875 3.87119 16.875 4.79167V6.66667M16.875 13.3333V15.2083C16.875 16.1288 16.1288 16.875 15.2083 16.875H13.3333"
        stroke={theme === 'light' ? '#434C69' : 'rgba(255, 255, 255, 0.259)'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1538 7.74153C10.2344 7.70121 10.2998 7.63583 10.3401 7.55519L10.8775 6.48033C11.0311 6.17322 11.4694 6.17322 11.6229 6.48033L12.1603 7.55519C12.2007 7.63583 12.266 7.70121 12.3467 7.74153L13.4215 8.27896C13.7286 8.43251 13.7286 8.87076 13.4215 9.02432L12.3467 9.56175C12.266 9.60207 12.2007 9.66745 12.1603 9.74809L11.6229 10.8229C11.4694 11.1301 11.0311 11.1301 10.8775 10.8229L10.3401 9.74809C10.2998 9.66745 10.2344 9.60207 10.1538 9.56175L9.07892 9.02432C8.77181 8.87076 8.77181 8.43251 9.07892 8.27896L10.1538 7.74153Z"
        fill={theme === 'light' ? '#434C69' : 'rgba(255, 255, 255, 0.259)'}
      />
      <path
        d="M7.14791 11.3278C7.1963 11.3036 7.23553 11.2644 7.25972 11.216L7.69329 10.3489C7.78542 10.1646 8.04837 10.1646 8.1405 10.3489L8.57407 11.216C8.59826 11.2644 8.63749 11.3036 8.68587 11.3278L9.55301 11.7614C9.73728 11.8535 9.73728 12.1164 9.55301 12.2086L8.68587 12.6421C8.63749 12.6663 8.59826 12.7056 8.57407 12.754L8.1405 13.6211C8.04837 13.8054 7.78542 13.8054 7.69329 13.6211L7.25972 12.754C7.23553 12.7056 7.1963 12.6663 7.14791 12.6421L6.28077 12.2086C6.09651 12.1164 6.09651 11.8535 6.28077 11.7614L7.14791 11.3278Z"
        fill={theme === 'light' ? '#434C69' : 'rgba(255, 255, 255, 0.259)'}
      />
    </svg>
  );
};

export default SearchMagicAi;
